import { AxiosStatic, AxiosPromise } from 'axios';
import { LoginCredentials, LoginInformation} from '../models/api-client';

class LoginService {
  public controllerUri: string;

  constructor(public axios: AxiosStatic, public baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
    this.controllerUri = 'Login/';
  }

  loginByUserPass(param: LoginCredentials): AxiosPromise<LoginInformation> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}LoginByUserPass`, param);
  }

  logout(): AxiosPromise<LoginInformation> {
    return this.axios.post(`${this.baseUrl + this.controllerUri}Logout`);
  }

  // loginByOsaId(guid: UserGuid): AxiosPromise<LoginInformation> {
  //   return this.axios.get(`${this.baseUrl + this.controllerUri}LoginByOsaId/${guid}`);
  // }
}

export default LoginService;
